import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CompanyDirectoryEntry,
  CompanyDirectoryPage,
  CompanyDirectorySearchParams
} from './company-directory.models';

@Injectable({ providedIn: 'root' })
export class CompanyDirectoryService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.aiServiceApiUrl}directory`;

  getCompanyIds(): Observable<number[]> {
    return this.http.get<number[]>(`${this.baseUrl}/companies`);
  }

  searchCompanies(params: CompanyDirectorySearchParams = {}): Observable<CompanyDirectoryPage> {
    let httpParams = new HttpParams();
    if (params.query) httpParams = httpParams.set('query', params.query);
    if (params.companyType) httpParams = httpParams.set('companyType', params.companyType);
    if (params.page !== undefined) httpParams = httpParams.set('page', String(params.page));
    if (params.size !== undefined) httpParams = httpParams.set('size', String(params.size));

    return this.http.get<CompanyDirectoryPage>(`${this.baseUrl}/companies/search`, { params: httpParams });
  }

  getCompany(id: number): Observable<CompanyDirectoryEntry> {
    return this.http.get<CompanyDirectoryEntry>(`${this.baseUrl}/companies/${id}`);
  }
}
